const LoadingOverlay = () => {
    return (
        <div className="absolute w-full h-full bg-white bg-opacity-80 z-[5]"></div>
    );
};

export default LoadingOverlay;
